<template>
<!-- <section class="uk-container uk-width-3-4@m uk-flex-center uk-margin-auto uk-margin">
</section> -->
<!--ARTICLE-->
<section class="uk-section uk-article">
    <div class="uk-container uk-container-small">
        <h2 class="uk-text-bold uk-h1 uk-margin-remove-adjacent uk-margin-remove-top">Informe 2021</h2>
        <p class="uk-article-meta">Written on  Noviembre 2022.</p>
        <p class="uk-text-lead">Introduccion 2021</p>
    </div>
    <!-- large image -->
    <!-- <div class="uk-container uk-section">
        <div class="uk-position-relative uk-visible-toggle uk-light" data-uk-slideshow="ratio: 7:3; animation: push; min-height: 270; velocity: 3">
            <ul class="uk-slideshow-items">
                <li>
                    <img data-src="https://picsum.photos/1200/550/?random=1" data-uk-img="target: !.uk-slideshow-items" alt="" data-uk-cover>
                    <div class="uk-position-bottom uk-position-medium uk-text-center uk-light">
                        <h3 class="uk-margin-remove">Sed consequat urna.</h3>
                        <p class="uk-margin-remove uk-visible@s">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                    </div>
                </li>
                <li>
                    <img data-src="https://picsum.photos/1200/550/?random=2" data-uk-img="target: !.uk-slideshow-items" alt="" data-uk-cover>
                    <div class="uk-position-bottom uk-position-medium uk-text-center uk-light">
                        <h3 class="uk-margin-remove">Sed consequat urna.</h3>
                        <p class="uk-margin-remove uk-visible@s">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                    </div>
                </li>
                <li>
                    <img data-src="https://picsum.photos/1200/550/?random=3" data-uk-img="target: !.uk-slideshow-items" alt="" data-uk-cover>
                    <div class="uk-position-bottom uk-position-medium uk-text-center uk-light">
                        <h3 class="uk-margin-remove">Sed consequat urna.</h3>
                        <p class="uk-margin-remove uk-visible@s">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                    </div>
                </li>
            </ul>
            <a class="uk-position-center-left uk-position-small uk-hidden-hover" href="#" data-uk-slidenav-previous="ratio: 1.5" data-uk-slideshow-item="previous"></a>
            <a class="uk-position-center-right uk-position-small uk-hidden-hover" href="#" data-uk-slidenav-next="ratio: 1.5" data-uk-slideshow-item="next"></a>
        </div>
    </div> -->
    <!-- /large image -->
    <!-- text -->
    <div class="uk-container uk-container-small">
        <h3>Marzo</h3>
        <p>En el mes de Marzo de 2021 el Movimiento Benito Quinquela Martín fue convocado a colaborar con la campaña de vacunación realizada en la sede de la fundación de Boca Social en el complejo de Casa Amarilla.</p>
        <figure>
            <img src="/images/informe/202101.jpg" data-src="" width="50%" alt="Alt text" class="lazy" data-uk-img>
            <img src="/images/informe/202102.jpg" data-src="" width="46%" alt="Alt text" class="lazy" data-uk-img>
            <figcaption class="uk-padding-small uk-text-center uk-text-muted">Caption of the image </figcaption>
        </figure>
        <p>En el mismo mes de Marzo el día 20 nos hemos juntado con el Sr. Sr. Diego Barovero presidente de Impulso Agrupación de Gente Arte y Letras, institución centenaria del Barrio de La Boca, en el que nos pusimos a disposición para realizar tareas en conjunto y servir de nexo con el Club Boca Juniors.</p>
        <blockquote class="twitter-tweet uk-align-center">
            <p lang="es" dir="ltr">Por la vuelta. Tras un año que se hizo largo volvimos a abrir nuestra sede y recibir amigos y socios. Nos visitaron Fabian Bazan del Movimiento Quinquela Martin, Pedro Veneroni y Gustavo López factótum de 
                <a href="https://twitter.com/ColeccionMose?ref_src=twsrc%5Etfw">@ColeccionMose</a> siempre con nuevos proyectos. Bienvenidos! 
                <a href="https://twitter.com/DBarovero?ref_src=twsrc%5Etfw">@DBarovero</a> 
                <a href="https://t.co/PJl2EIcJQt">pic.twitter.com/PJl2EIcJQt</a>
            </p>&mdash; Impulso Agrupacion de Gente de Arte y Letras (@AgrupImpulso) 
            <a href="https://twitter.com/AgrupImpulso/status/1373231322257362948?ref_src=twsrc%5Etfw">March 20, 2021</a>
        </blockquote>
        <h3>Abril</h3>
        <p>En el mes de Abril, hemos donado al merendero la Hormiguita Viajera, ubicado en el Barrio de La Boca 5 mesitas y 20 sillitas.</p>
                    <!-- large image -->
    <div class="uk-container">
        <div class="uk-position-relative uk-visible-toggle uk-light" data-uk-slideshow="ratio: 7:3; animation: push; min-height: 270; velocity: 3">
            <ul class="uk-slideshow-items">
                <li>
                    <img data-src="/images/informe/202103.jpg" data-uk-img="target: !.uk-slideshow-items" alt="" data-uk-cover>
                </li>
                <li>
                    <img data-src="/images/informe/202104.jpg" data-uk-img="target: !.uk-slideshow-items" alt="" data-uk-cover>
                </li>
            </ul>
            <a class="uk-position-center-left uk-position-small uk-hidden-hover" href="#" data-uk-slidenav-previous="ratio: 1.5" data-uk-slideshow-item="previous"></a>
            <a class="uk-position-center-right uk-position-small uk-hidden-hover" href="#" data-uk-slidenav-next="ratio: 1.5" data-uk-slideshow-item="next"></a>
        </div>
    </div>
    <!-- /large image -->
        <p>El día 28 de Abril el Movimiento Benito Quinquela Martín entregó a los Bomberos Voluntarios dela República de La Boca un pergamino firmado por sus integrantes con motivo a las primeras 50.000 hs. de voluntariado. El mismo fue recibido por su presidente Ing. Carlos Milanesi.</p>
        <figure>
            <img src="/images/informe/202105.jpg" data-src="" alt="Alt text" class="lazy" data-uk-img>
            <figcaption class="uk-padding-small uk-text-center uk-text-muted">Caption of the image </figcaption>
        </figure>
        <figure>
            <img src="/images/informe/202106.jpg" data-src="" alt="Alt text" class="lazy" data-uk-img>
            <figcaption class="uk-padding-small uk-text-center uk-text-muted">Caption of the image </figcaption>
        </figure>
        <figure>
            <img src="/images/informe/202107.jpg" data-src="" alt="Alt text" class="lazy" data-uk-img>
            <figcaption class="uk-padding-small uk-text-center uk-text-muted">Caption of the image </figcaption>
        </figure>
        <h3>Mayo</h3>
        <p>El 12 de mayo pasado oficiamos de nexo y acompañamos a las autoridades del Club Social Cultural y Deportivo Bohemios de la República de La Boca fundado el 9 de Julio de 1938, encabezado por su tesorero Adrián Falcone, a reunirse con autoridades de la Fundación Boca Social a los efectos de poder coordinar acciones en conjunto entre ambas instituciones</p>
        <figure>
            <img src="/images/informe/202108.jpg" data-src="" alt="Alt text" class="lazy" data-uk-img>
            <figcaption class="uk-padding-small uk-text-center uk-text-muted">Caption of the image </figcaption>
        </figure>
        <h3>Julio</h3>
        <p>En Julio de 2021 acompañamos a la Fundación Boca Juniors en su primera actividad social en el barrio, en el que se articuló con la Secretaría de Abordaje Integral del Ministerio de Desarrollo Social dos jornadas de Salud Preventiva para vecinos y vecinas del barrio de La Boca.</p>
        <div class="uk-container">
        <div class="uk-position-relative uk-visible-toggle uk-light" data-uk-slideshow="ratio: 7:3; animation: push; min-height: 270; velocity: 3">
            <ul class="uk-slideshow-items">
                <li>
                    <img data-src="/images/informe/202109.jpg" data-uk-img="target: !.uk-slideshow-items" alt="" data-uk-cover>
                </li>
                <li>
                    <img data-src="/images/informe/202110.jpg" data-uk-img="target: !.uk-slideshow-items" alt="" data-uk-cover>
                </li>
                <li>
                    <img data-src="/images/informe/202111.jpg" data-uk-img="target: !.uk-slideshow-items" alt="" data-uk-cover>
                </li>
            </ul>
            <a class="uk-position-center-left uk-position-small uk-hidden-hover" href="#" data-uk-slidenav-previous="ratio: 1.5" data-uk-slideshow-item="previous"></a>
            <a class="uk-position-center-right uk-position-small uk-hidden-hover" href="#" data-uk-slidenav-next="ratio: 1.5" data-uk-slideshow-item="next"></a>
        </div>
    </div>
        <p>En Julio de 2021 fuimos invitados por el Club Bohemios a la inauguración de la obra “Diego Iluminado” del artista Alejandro Marmó.</p>
        <div class="uk-container">
        <div class="uk-position-relative uk-visible-toggle uk-light" data-uk-slideshow="ratio: 7:3; animation: push; min-height:300; velocity: 3">
            <ul class="uk-slideshow-items">
                <li>
                    <img data-src="/images/informe/202112.jpg" data-uk-img="target: !.uk-slideshow-items" alt="" data-uk-cover>
                </li>
                <li>
                    <img data-src="/images/informe/202113.jpg" data-uk-img="target: !.uk-slideshow-items" alt="" data-uk-cover>
                </li>
                <li>
                    <img data-src="/images/informe/202114.jpg" data-uk-img="target: !.uk-slideshow-items" alt="" data-uk-cover>
                </li>
            </ul>
            <a class="uk-position-center-left uk-position-small uk-hidden-hover" href="#" data-uk-slidenav-previous="ratio: 1.5" data-uk-slideshow-item="previous"></a>
            <a class="uk-position-center-right uk-position-small uk-hidden-hover" href="#" data-uk-slidenav-next="ratio: 1.5" data-uk-slideshow-item="next"></a>
        </div>
    </div>
        <h3>Agosto</h3>
        <p>En agosto de 2021 para el día del niño y la niña, colaboramos con la Despensa Melina que entregó juguetes a más de 200 niños y niñas de la República de La Boca.</p>
        <div class="uk-container">
            <div class="uk-position-relative uk-visible-toggle uk-light" data-uk-slideshow="ratio: 7:3; animation: push; min-height:300; velocity: 3">
                <ul class="uk-slideshow-items">
                    <li>
                        <img data-src="/images/informe/202115.jpg" data-uk-img="target: !.uk-slideshow-items" alt="" data-uk-cover>
                    </li>
                    <li>
                        <img data-src="/images/informe/202116.jpg" data-uk-img="target: !.uk-slideshow-items" alt="" data-uk-cover>
                    </li>
                    <li>
                        <img data-src="/images/informe/202117.jpg" data-uk-img="target: !.uk-slideshow-items" alt="" data-uk-cover>
                    </li>
                </ul>
                <a class="uk-position-center-left uk-position-small uk-hidden-hover" href="#" data-uk-slidenav-previous="ratio: 1.5" data-uk-slideshow-item="previous"></a>
                <a class="uk-position-center-right uk-position-small uk-hidden-hover" href="#" data-uk-slidenav-next="ratio: 1.5" data-uk-slideshow-item="next"></a>
            </div>
        </div>
        <p>En Agosto de 2021, fuimos invitados por distintas instituciones del barrio a participar en la organización del 151 Cumpleaños de la República de La Boca, celebrado el sábado 28 de agosto en la plaza de Los Bomberos.</p>
        <figure>
            <img src="/images/informe/202118.jpg" data-src="" alt="Alt text" class="lazy" data-uk-img>
            <figcaption class="uk-padding-small uk-text-center uk-text-muted">Caption of the image </figcaption>
        </figure>
        <figure>
            <img src="/images/informe/202119.jpg" data-src="" alt="Alt text" class="lazy" data-uk-img>
            <figcaption class="uk-padding-small uk-text-center uk-text-muted">Caption of the image </figcaption>
        </figure>
        <h3>Septiembre</h3>
        <p>En Septiembre de 2021, participamos activamente en la Campaña “Veo Veo” que atendió en sus dos primeras jornadas a 250 chicos y chicas del barrio de La Boca cuyo director es Javier Rozzi, vicepresidente del Movimiento Quinquela.</p>
        <div class="uk-container">
            <div class="uk-position-relative uk-visible-toggle uk-light" data-uk-slideshow="ratio: 7:3; animation: push; min-height:300; velocity: 3">
                <ul class="uk-slideshow-items">
                    <li>
                        <img data-src="/images/informe/202120.jpg" data-uk-img="target: !.uk-slideshow-items" alt="" data-uk-cover>
                    </li>
                    <li>
                        <img data-src="/images/informe/202121.jpg" data-uk-img="target: !.uk-slideshow-items" alt="" data-uk-cover>
                    </li>
                    <li>
                        <img data-src="/images/informe/202122.jpg" data-uk-img="target: !.uk-slideshow-items" alt="" data-uk-cover>
                    </li>
                </ul>
                <a class="uk-position-center-left uk-position-small uk-hidden-hover" href="#" data-uk-slidenav-previous="ratio: 1.5" data-uk-slideshow-item="previous"></a>
                <a class="uk-position-center-right uk-position-small uk-hidden-hover" href="#" data-uk-slidenav-next="ratio: 1.5" data-uk-slideshow-item="next"></a>
            </div>
        </div>
        <p>Participamos activamente en el Departamento de Deportes Amateurs que preside el Sr. Martin Mendiguren, aportando nuestro granito de arena para ser cada día para volver a ser un Club Atlético.</p>
        <figure>
            <img src="/images/informe/202123.jpg" data-src="" alt="Alt text" class="lazy" data-uk-img>
            <figcaption class="uk-padding-small uk-text-center uk-text-muted">Caption of the image </figcaption>
        </figure>
        <h3>Octubre</h3>
        <p>En Octubre visitamos el Museo Benito Quinquela Martin, nos recibió su presidente el Sr. Victor Fernandez quien después de darnos una visita guiada a toda la vida y obra del Maestro, escuchó nuestros proyectos y se comprometió a realizar tareas en conjunto en el año 2022.</p>
        <figure>
            <img src="/images/informe/202124.jpg" data-src="" alt="Alt text" class="lazy" data-uk-img>
            <figcaption class="uk-padding-small uk-text-center uk-text-muted">Caption of the image </figcaption>
        </figure>
        <figure>
            <img src="/images/informe/202125.jpg" data-src="" alt="Alt text" class="lazy" data-uk-img>
            <figcaption class="uk-padding-small uk-text-center uk-text-muted">Caption of the image </figcaption>
        </figure>
        <p>El dia 29 de Octubre hicimos en la confitería del Club Atlético Boca Juniors una cena de camaradería con los integrantes del movimiento Quinquela de la Republica de La Boca y Ramos Mejía en la que invitamos al Presidente del Departamento de Socios Alejandro Cosentino.</p>
        <div class="uk-container uk-container-small uk-margin-medium">
            <div class="uk-grid uk-grid-medium uk-child-width-1-2 uk-child-width-1-3@s" data-uk-grid data-uk-lightbox>
                <div v-for='item in items' :key="item">
                    <figure>
                        <a data-caption="Image Caption" title="Image Caption" href="{{item.foto}}">
                            <img :src="`../images/informe/${item.foto}`" width="300" height="200" alt="Image Caption" data-uk-img>
                        </a>
                    </figure>
                </div>
            </div>
        </div>
        <h3>Noviembre</h3>
        <p>El día 3 de noviembre tuvimos una reunión con el presidente del Club Atletico Boca Juniors donde presentamos una carpeta con lo realizado hasta el momento ese momento y desde que comenzó la pandemia. Y quedamos en reunirnos periódicamente para ir presentando lo que realizamos en el barrio y llevar proyectos que contribuyan a estrechar la relación entre El Club y el Barrio.</p>
        <figure>
            <img src="/images/informe/202135.jpg" data-src="" alt="Alt text" class="lazy" data-uk-img>
            <figcaption class="uk-padding-small uk-text-center uk-text-muted">Caption of the image </figcaption>
        </figure>
        <p>El día 6 de noviembre comenzamos con la colecta de donación de juguetes que concluiría en la entrega de los mismos el dia 19 de diciembre. Durante todos los sábados de noviembre y los dos primeros sábados de diciembre, pusimos postas de donaciones en la Plaza Colombia en Barracas, en Catalinas Sur en La Boca, en el Parque Las Heras en Palermo y en Ramos Mejía.</p>
        <div class="uk-container uk-container-small uk-margin-medium">
            <div class="uk-grid uk-grid-medium uk-child-width-1-2 uk-child-width-1-2@s" data-uk-grid data-uk-lightbox>
                <div v-for='item in itemsv2' :key="item">
                    <figure>
                        <a data-caption="Image Caption" title="Image Caption" href="{{item.foto}}">
                            <img :src="`../images/informe/${item.foto}`" alt="Image Caption" data-uk-img>
                        </a>
                    </figure>
                </div>
            </div>
        </div>
        <figure>
            <img src="/images/informe/202140.jpg" data-src="" alt="Alt text" class="lazy" data-uk-img>
            <figcaption class="uk-padding-small uk-text-center uk-text-muted">Caption of the image </figcaption>
        </figure>
        <p>El día 21 de noviembre participamos de la bicicleteada en la presentación de la vuelta de San Juan que se realizó por las calles de la Boca y en la que participó el famoso ciclista Peter Sagan entre otras importantes personalidades.</p>
        <div class="uk-container">
            <div class="uk-position-relative uk-visible-toggle uk-light" data-uk-slideshow="ratio: 7:3; animation: push; min-height: 270; velocity: 3">
                <ul class="uk-slideshow-items">
                    <li>
                        <img data-src="/images/informe/202141.jpg" data-uk-img="target: !.uk-slideshow-items" alt="" data-uk-cover>
                    </li>
                    <li>
                        <img data-src="/images/informe/202121.jpg" data-uk-img="target: !.uk-slideshow-items" alt="" data-uk-cover>
                    </li>
                    <li>
                        <img data-src="/images/informe/202143.jpg" data-uk-img="target: !.uk-slideshow-items" alt="" data-uk-cover>
                    </li>
                </ul>
                <a class="uk-position-center-left uk-position-small uk-hidden-hover" href="#" data-uk-slidenav-previous="ratio: 1.5" data-uk-slideshow-item="previous"></a>
                <a class="uk-position-center-right uk-position-small uk-hidden-hover" href="#" data-uk-slidenav-next="ratio: 1.5" data-uk-slideshow-item="next"></a>
            </div>
        </div>
        <h3>Diciembre</h3>
        <p>El 8 de Diciembre en ocasión de disputarse la final de la Copa Argentina viajamos a la provincia de Santiago del Estero a alentar a nuestro querido Boca Juniors, y nos trajimos la Copa!.</p>
        <figure>
            <img src="/images/informe/202144.jpg" data-src="" alt="Alt text" class="lazy" data-uk-img>
            <figcaption class="uk-padding-small uk-text-center uk-text-muted">Caption of the image </figcaption>
        </figure>
        <figure>
            <img src="/images/informe/202145.jpg" data-src="" alt="Alt text" class="lazy" data-uk-img>
            <figcaption class="uk-padding-small uk-text-center uk-text-muted">Caption of the image </figcaption>
        </figure>
        <p>El 19 de Diciembre entregamos los juguetes que recibimos de las donaciones conseguidas durante los meses de Noviembre y Diciembre. La entrega se realizó en la Despensa Melina sita en la calle Olavarria y Palos de la República de La Boca.</p>
        <div class="uk-container uk-container-small uk-margin-medium">
            <div class="uk-grid uk-grid-medium uk-child-width-1-2 uk-child-width-1-2@s" data-uk-grid data-uk-lightbox>
                <div v-for='item in itemsv3' :key="item">
                    <figure>
                        <a data-caption="Image Caption" title="Image Caption" href="{{item.foto}}">
                            <img :src="`../images/informe/${item.foto}`" alt="Image Caption" data-uk-img>
                        </a>
                    </figure>
                </div>
            </div>
        </div>
        <p>Ha sido un año de muchas alegrías y tristezas para el Movimiento Quinquela Martín, un año en el que podemos darnos por satisfechos que lo que dimos con todo nuestro corazón llegó donde queríamos que llegue y lloramos y reimos y nos abrazamos. El 2022 nos encontrará otra vez juntos, hombro con hombro haciendo cosas para el Barrio y para los socios y socias, de corazón muchas gracias.</p>
        <figure>
            <img src="/images/informe/202152.jpg" data-src="" alt="Alt text" class="lazy" data-uk-img>
            <figcaption class="uk-padding-small uk-text-center uk-text-muted">Caption of the image </figcaption>
        </figure>
    </div>
    <h2 class="uk-heading-line uk-text-center"><span>Gracias Ani</span></h2>
    <section class="uk-section uk-section-small">
			<div id="author-wrap" class="uk-container uk-container-small">
				<div class="uk-grid uk-grid-medium uk-flex uk-flex-middle" data-uk-grid>
					<div class="uk-width-auto">
						<img src="/images/informe/202153.jpg" alt="" width="350" class="uk-border-circle">
					</div>
					<div class="uk-width-expand">
						<h4 class="uk-margin-remove uk-text-bold">Analia Galeano</h4>
						<span class="uk-text-small uk-text-muted">1972 -  ∞</span>
					</div>
				</div>
			</div>
		</section>
    <!-- text -->
    <!-- gallery -->
    <!-- <div class="uk-container uk-container-small uk-margin-medium">
        <div class="uk-grid uk-grid-medium uk-child-width-1-2 uk-child-width-1-3@s" data-uk-grid data-uk-lightbox>
            <div>
                <figure>
                    <a data-caption="Image Caption" title="Image Caption" href="https://picsum.photos/1200/800?image=1072">
                        <img data-src="https://picsum.photos/300/200/?random=1" width="300" height="200" alt="Image Caption" data-uk-img>
                    </a>
                    <figcaption class="uk-text-small uk-text-muted uk-text-center uk-padding-small uk-visible@s">Aenean vitae est</figcaption>
                </figure>
            </div>
            
            <div>
                <figure>
                    <a data-caption="Image Caption" title="Image Caption" href="https://picsum.photos/1200/800?image=1072">
                        <img data-src="https://picsum.photos/300/200/?random=2" width="300" height="200" alt="Image Caption" data-uk-img>
                    </a>
                    <figcaption class="uk-text-small uk-text-muted uk-text-center uk-padding-small uk-visible@s">Aenean vitae est</figcaption>
                </figure>
            </div>
            
            <div>
                <figure>
                    <a data-caption="Image Caption" title="Image Caption" href="https://picsum.photos/1200/800?image=1072">
                        <img data-src="https://picsum.photos/300/200/?random=3" width="300" height="200" alt="Image Caption" data-uk-img>
                    </a>
                    <figcaption class="uk-text-small uk-text-muted uk-text-center uk-padding-small uk-visible@s">Aenean vitae est</figcaption>
                </figure>
            </div>
            
            <div>
                <figure>
                    <a data-caption="Image Caption" title="Image Caption" href="https://picsum.photos/1200/800?image=1072">
                        <img data-src="https://picsum.photos/300/200/?random=4" width="300" height="200" alt="Image Caption" data-uk-img>
                    </a>
                    <figcaption class="uk-text-small uk-text-muted uk-text-center uk-padding-small uk-visible@s">Aenean vitae est</figcaption>
                </figure>
            </div>
            
            <div>
                <figure>
                    <a data-caption="Image Caption" title="Image Caption" href="https://picsum.photos/1200/800?image=1072">
                        <img data-src="https://picsum.photos/300/200/?random=5" width="300" height="200" alt="Image Caption" data-uk-img>
                    </a>
                    <figcaption class="uk-text-small uk-text-muted uk-text-center uk-padding-small uk-visible@s">Aenean vitae est</figcaption>
                </figure>
            </div>
            
            <div>
                <figure>
                    <a data-caption="Image Caption" title="Image Caption" href="https://picsum.photos/1200/800?image=1072">
                        <img data-src="https://picsum.photos/300/200/?random=6" width="300" height="200" alt="Image Caption" data-uk-img>
                    </a>
                    <figcaption class="uk-text-small uk-text-muted uk-text-center uk-padding-small uk-visible@s">Aenean vitae est</figcaption>
                </figure>
            </div>
            
            
        </div>
    </div> -->
    <!-- /gallery -->
</section>
<section class="uk-section uk-section-muted">
    <div class="uk-container">
        <h2 class="uk-text-bold">Más informes</h2>
        <div data-uk-slider="velocity: 5">
            <div class="uk-position-relative">
                <div class="uk-slider-container">
                    <ul class="uk-slider-items uk-child-width-1-2@s uk-child-width-1-3@m uk-grid uk-grid-medium">
                        <li>
                            <!-- card -->
                            <div>
                                <div class="uk-card uk-card-default uk-card-small" style="box-shadow: none;">
                                    <div class="uk-card-media-top">
                                        <a href="#"><img data-src="https://unsplash.it/620/350/?random=1" width="620" height="350" data-uk-img="target: !.uk-slideshow-items" alt=""></a>
                                    </div>
                                    <!-- <div class="uk-card-header">
                                       <div class="uk-grid-small uk-flex-middle" data-uk-grid>
                                            <div class="uk-width-auto">
                                                <img class="uk-border-circle" alt="" width="40" height="40" src="https://unsplash.it/60/60/?random">
                                            </div>
                                             <div class="uk-width-expand">
                                                <h6 class="uk-margin-remove-bottom uk-text-bold">Author Name</h6>
                                                <p class="uk-text-meta uk-margin-remove-top uk-text-small"><time datetime="2016-04-01T19:00">April 01, 2016</time></p>
                                            </div> 
                                        </div>
                                    </div>-->
                                    <div class="uk-card-body">
                                        <h4 class="uk-margin-small-bottom uk-text-bold">Informe 2020</h4>
                                        <span class="uk-text-small">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.</span>
                                        <a class="uk-button uk-button-text uk-text-bold uk-margin-small uk-card-footer" href="">LEER</a>
                                    </div>
                                </div>
                            </div>
                            <!-- /card -->
                        </li>
                        <li>
                            <!-- card -->
                            <div>
                                <div class="uk-card uk-card-default uk-card-small" style="box-shadow: none;">
                                    <div class="uk-card-media-top">
                                        <a href="#"><img data-src="https://unsplash.it/620/350/?random=2" width="620" height="350" data-uk-img="target: !.uk-slideshow-items" alt=""></a>
                                    </div>
                                    <!-- <div class="uk-card-header">
                                       <div class="uk-grid-small uk-flex-middle" data-uk-grid>
                                            <div class="uk-width-auto">
                                                <img class="uk-border-circle" alt="" width="40" height="40" src="https://unsplash.it/60/60/?random">
                                            </div>
                                             <div class="uk-width-expand">
                                                <h6 class="uk-margin-remove-bottom uk-text-bold">Author Name</h6>
                                                <p class="uk-text-meta uk-margin-remove-top uk-text-small"><time datetime="2016-04-01T19:00">April 01, 2016</time></p>
                                            </div> 
                                        </div>
                                    </div>-->
                                    <div class="uk-card-body">
                                        <h4 class="uk-margin-small-bottom uk-text-bold">Teatro Verdi</h4>
                                        <span class="uk-text-small">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.</span>
                                        <a class="uk-button uk-button-text uk-text-bold uk-margin-small uk-card-footer" href="">LEER</a>
                                    </div>
                                </div>
                            </div>
                            <!-- /card -->
                        </li>
                        <li>
                            <!-- card -->
                            <div>
                                <div class="uk-card uk-card-default uk-card-small" style="box-shadow: none;">
                                    <div class="uk-card-media-top">
                                        <a href="#"><img data-src="https://unsplash.it/620/350/?random=3" width="620" height="350" data-uk-img="target: !.uk-slideshow-items" alt=""></a>
                                    </div>
                                    <!-- <div class="uk-card-header">
                                       <div class="uk-grid-small uk-flex-middle" data-uk-grid>
                                            <div class="uk-width-auto">
                                                <img class="uk-border-circle" alt="" width="40" height="40" src="https://unsplash.it/60/60/?random">
                                            </div>
                                             <div class="uk-width-expand">
                                                <h6 class="uk-margin-remove-bottom uk-text-bold">Author Name</h6>
                                                <p class="uk-text-meta uk-margin-remove-top uk-text-small"><time datetime="2016-04-01T19:00">April 01, 2016</time></p>
                                            </div> 
                                        </div>
                                    </div>-->
                                    <div class="uk-card-body">
                                        <h4 class="uk-margin-small-bottom uk-text-bold">Campaña Veo Veo</h4>
                                        <span class="uk-text-small">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.</span>
                                        <a class="uk-button uk-button-text uk-text-bold uk-margin-small uk-card-footer" href="">LEER</a>
                                    </div>
                                </div>
                            </div>
                            <!-- /card -->
                        </li>
                    </ul>
                </div>
                <ul class="uk-slider-nav uk-dotnav uk-flex-center uk-margin">
                    
                </ul>
                <div class="uk-hidden@m uk-light">
                    <a class="uk-position-center-left uk-position-small" href="#" data-uk-slidenav-previous data-uk-slider-item="previous"></a>
                    <a class="uk-position-center-right uk-position-small" href="#" data-uk-slidenav-next data-uk-slider-item="next"></a>
                </div>
                <div class="uk-visible@m">
                    <a class="uk-position-center-left-out uk-position-small" href="#" data-uk-slidenav-previous data-uk-slider-item="previous"></a>
                    <a class="uk-position-center-right-out uk-position-small" href="#" data-uk-slidenav-next data-uk-slider-item="next"></a>
                </div>
            </div>
            
        </div>
    </div>
</section>
</template>
<script>
export default {
    data() {
        return {
            items: [
                { foto: '202126.jpg' },
                { foto: '202127.jpg' },
                { foto: '202128.jpg' },
                { foto: '202129.jpg' },
                { foto: '202130.jpg' },
                { foto: '202131.jpg' },
                { foto: '202132.jpg' },
                { foto: '202133.jpg' },
                { foto: '202134.jpg' }
            ],
            itemsv2: [
                { foto: '202136.jpg' },
                { foto: '202137.jpg' },
                { foto: '202138.jpg' },
                { foto: '202139.jpg' }
            ],
            itemsv3: [
                { foto: '202146.jpg' },
                { foto: '202147.jpg' },
                { foto: '202148.jpg' },
                { foto: '202149.jpg' },
                { foto: '202148.jpg' },
                { foto: '202150.jpg' }
            ]
        }
    }
}
</script>